import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import { localizePath, useLang } from '../i18n';

import KaynakliImalat from '../images/kaynakli_imalat.jpg';
import LazerKesim from '../images/lazer_kesim.jpeg';
import AbkantBukum from '../images/abkand_bukum.jpeg';
import Tasarim from '../images/tasarim.webp';
import FilmVideo from '../images/film_tasarimdan_teslimata.mp4';
import FilmPoster from '../images/film_tasarimdan_teslimata.jpg';

const SERVICE_IMAGES = [
  { image: LazerKesim, link: '/services#lazer-kesim' },
  { image: AbkantBukum, link: '/services#abkant-bukum' },
  { image: KaynakliImalat, link: '/services#kaynakli-imalat' },
  { image: Tasarim, link: '/services#tasarim' },
];

const CONTENT = {
  tr: {
    title: undefined, // the default title from index.html
    services: [
      {
        title: 'Lazer Kesim',
        description: 'HRP-DKP-ST37-52 SAC: 0.5mm - 20mm, Paslanmaz: 0.5mm - 10mm, Alüminyum: 0.5mm - 10mm. Maksimum 1500x3000 sac işleme kapasitesi.',
      },
      {
        title: 'Abkant Büküm',
        description: 'Hassasiyet değeri yüksek abkant pres tezgahlarımızla tolerans değerlerine uygun büküm. Maksimum 3000 mm boyunda bükme kapasitesi.',
      },
      {
        title: 'Kaynaklı İmalat',
        description: 'Uzman personelimiz ile otomotiv, makine, raylı sistemler, savunma sanayi ve mobilya sektörlerine kaynak hizmeti.',
      },
      {
        title: 'Tasarım',
        description: '2D ve 3D modelleme, tasarım ve modellenmiş her türlü veriyi üretebilme tecrübe ve yeteneği.',
      },
    ],
    learnMore: 'Detaylı Bilgi',
    servicesHeading: 'Hizmetlerimiz',
    servicesLead: 'Endüstriyel ihtiyaçlarınıza modern teknoloji ve uzman kadromuzla çözüm üretiyoruz.',
    aboutHeading: 'Nitelikli Ürün, Zamanında Teslimat',
    aboutParagraphs: [
      'Firmamız kuruluş itibarı ile sektörde bulunan nitelikli ürün üretme ve çözüm odaklı çalışma prensibine yeni bir bakış açısı kazandırmak istemektedir.',
      'Zamanın ve hammaddenin değerinin farkında olarak lazer kesim, abkant büküm, kaynaklı imalat, proje bazlı işler ile tasarım alanında hem yurtiçi hem de yurtdışı hizmet vermek amacı ile hareket etmektedir.',
    ],
    contactCta: 'Bizimle İletişime Geçin',
    stats: ['Yıllık Tecrübe', 'mm Lazer Kesim Tablası', 'Maks. Sac Kalınlığı'],
    filmHeading: 'Tasarımdan teslimata',
    filmBody: 'Bir otobüs koltuk menteşe kolunun yolculuğu: tasarım ve açınım, lazer kesim, abkant büküm, kaynak ve toz boya.',
    filmLink: 'Tüm videolar',
    resourcesHeading: 'Bilgi Merkezi',
    resourcesBody: 'Süreç videoları, sac metal tasarım rehberi, malzeme rehberi, sac ağırlığı ve büküm payı hesaplayıcıları.',
    resourcesLinks: [['/research/videos', 'Video Kütüphanesi'], ['/research/design-guide', 'Tasarım Rehberi'], ['/research/calculators', 'Hesaplama Araçları']],
  },
  en: {
    title: 'Laser Cutting, Press Brake Bending and Welded Fabrication in Bursa',
    description: 'AKKA Demir Çelik: laser cutting, press brake bending, welded fabrication and design services in Bursa, Türkiye. ISO 9001, ISO 14001 and ISO 45001 certified.',
    services: [
      {
        title: 'Laser Cutting',
        description: 'HRP-DKP-ST37-52 sheet: 0.5–20 mm, stainless steel: 0.5–10 mm, aluminium: 0.5–10 mm. Sheets up to 1500×3000 mm.',
      },
      {
        title: 'Press Brake Bending',
        description: 'High-precision press brakes for bends within your tolerances. Bending lengths up to 3000 mm.',
      },
      {
        title: 'Welded Fabrication',
        description: 'Welding by our expert staff for the automotive, machinery, rail, defence and furniture industries.',
      },
      {
        title: 'Design',
        description: '2D and 3D modelling, design, and the experience to manufacture from any modelled data.',
      },
    ],
    learnMore: 'Learn more',
    servicesHeading: 'Our Services',
    servicesLead: 'We meet your industrial needs with modern technology and an expert team.',
    aboutHeading: 'Quality Products, On-Time Delivery',
    aboutParagraphs: [
      'Since its founding, our company has set out to bring a fresh perspective to producing quality products and working in a solution-focused way.',
      'Aware of the value of time and raw materials, we provide laser cutting, press brake bending, welded fabrication, project-based work and design services in Türkiye and abroad.',
    ],
    contactCta: 'Get in Touch',
    stats: ['Years of Experience', 'mm Laser Cutting Bed', 'Max. Sheet Thickness'],
    filmHeading: 'From design to delivery',
    filmBody: 'The journey of a bus seat hinge arm: design and flat pattern, laser cutting, press brake bending, welding and powder coating.',
    filmLink: 'All videos',
    resourcesHeading: 'Resource Center',
    resourcesBody: 'Process videos, a sheet metal design guide, a materials guide, and sheet weight and bend allowance calculators.',
    resourcesLinks: [['/research/videos', 'Video Library'], ['/research/design-guide', 'Design Guide'], ['/research/calculators', 'Calculators']],
  },  de: {
    title: 'Laserschneiden, Abkanten und Schweißbaugruppen aus Bursa',
    description: 'AKKA Demir Çelik: Laserschneiden, Abkanten, Schweißbaugruppen und Konstruktion in Bursa, Türkei. Zertifiziert nach ISO 9001, ISO 14001 und ISO 45001.',
    services: [
      {
        title: 'Laserschneiden',
        description: 'Bleche HRP, DKP, St37–52: 0,5–20 mm, Edelstahl: 0,5–10 mm, Aluminium: 0,5–10 mm. Blechformate bis 1500 × 3000 mm.',
      },
      {
        title: 'Abkanten',
        description: 'Präzise Abkantpressen für Biegungen innerhalb Ihrer Toleranzen. Biegelängen bis 3000 mm.',
      },
      {
        title: 'Schweißbaugruppen',
        description: 'Schweißarbeiten durch erfahrene Fachkräfte für Automobilindustrie, Maschinenbau, Bahntechnik, Verteidigung und Möbelindustrie.',
      },
      {
        title: 'Konstruktion',
        description: '2D- und 3D-Modellierung, Konstruktion und die Erfahrung, nach beliebigen Modelldaten zu fertigen.',
      },
    ],
    learnMore: 'Mehr erfahren',
    servicesHeading: 'Unsere Leistungen',
    servicesLead: 'Wir lösen Ihre industriellen Aufgaben mit moderner Technik und einem erfahrenen Team.',
    aboutHeading: 'Qualität und pünktliche Lieferung',
    aboutParagraphs: [
      'Seit unserer Gründung wollen wir der Branche einen neuen Blick auf Qualitätsfertigung und lösungsorientiertes Arbeiten geben.',
      'Im Bewusstsein, wie wertvoll Zeit und Rohstoffe sind, bieten wir Laserschneiden, Abkanten, Schweißbaugruppen, projektbezogene Fertigung und Konstruktion für Kunden in der Türkei und im Ausland an.',
    ],
    contactCta: 'Kontakt aufnehmen',
    stats: ['Jahre Erfahrung', 'mm Laserschneidtisch', 'Max. Blechdicke'],
    filmHeading: 'Von der Konstruktion bis zur Lieferung',
    filmBody: 'Der Weg eines Scharnierarms für Bussitze: Konstruktion und Abwicklung, Laserschneiden, Abkanten, Schweißen und Pulverbeschichtung.',
    filmLink: 'Alle Videos',
    resourcesHeading: 'Wissenszentrum',
    resourcesBody: 'Prozessvideos, ein Konstruktionsleitfaden für Blechteile, ein Werkstoffleitfaden sowie Rechner für Blechgewicht und Biegezugabe.',
    resourcesLinks: [['/research/videos', 'Videothek'], ['/research/design-guide', 'Konstruktionsleitfaden'], ['/research/calculators', 'Rechner']],
  },
};

const Home = () => {
  const lang = useLang();
  const c = CONTENT[lang];
  const lp = (path) => localizePath(path, lang);

  return (
    <Layout title={c.title} description={c.description}>
      <Hero />

      <section id="services" className="py-20 bg-gray-50 scroll-mt-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{c.servicesHeading}</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded"></div>
            <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">{c.servicesLead}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {c.services.map((service, index) => (
              <ServiceCard
                key={service.title}
                title={service.title}
                description={service.description}
                image={SERVICE_IMAGES[index].image}
                link={lp(SERVICE_IMAGES[index].link)}
                linkLabel={c.learnMore}
              />
            ))}
          </div>
        </div>
      </section>

      {/* How we make it: the design-to-delivery film */}
      <section className="py-20 bg-[#0b0e14] text-white">
        <div className="container mx-auto px-4 grid gap-10 lg:grid-cols-5 items-center">
          <video className="lg:col-span-3 w-full aspect-video rounded-xl bg-black shadow-2xl" src={FilmVideo} poster={FilmPoster}
            controls muted playsInline preload="none" aria-label={c.filmHeading} />
          <div className="lg:col-span-2">
            <h2 className="text-3xl md:text-4xl font-bold mt-0 mb-4">{c.filmHeading}</h2>
            <p className="text-lg text-gray-300 mb-6">{c.filmBody}</p>
            <Link to={lp('/research/videos')} className="inline-block px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white hover:text-white font-semibold transition duration-300">
              {c.filmLink} &rarr;
            </Link>
          </div>
        </div>
      </section>

      {/* Features / Info Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{c.aboutHeading}</h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">{c.aboutParagraphs[0]}</p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">{c.aboutParagraphs[1]}</p>
              <Link to={lp('/contact')} className="inline-block px-8 py-3 bg-gray-900 text-white hover:text-white font-semibold rounded-lg hover:bg-gray-800 transition duration-300">
                {c.contactCta}
              </Link>
            </div>
            <div className="md:w-1/2 grid grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 lg:p-6 rounded-xl text-center">
                <span className="block text-4xl font-bold text-blue-600 mb-2">10+</span>
                <span className="text-gray-700 font-medium">{c.stats[0]}</span>
              </div>
              <div className="bg-blue-50 p-4 lg:p-6 rounded-xl text-center">
                <span className="block text-xl lg:text-2xl xl:text-4xl font-bold text-blue-600 mb-2 whitespace-nowrap">1500×3000</span>
                <span className="text-gray-700 font-medium">{c.stats[1]}</span>
              </div>
              <div className="bg-blue-50 p-4 lg:p-6 rounded-xl text-center">
                <span className="block text-4xl font-bold text-blue-600 mb-2">20 mm</span>
                <span className="text-gray-700 font-medium">{c.stats[2]}</span>
              </div>
              <Link to={lp('/company#sertifikalar')} className="bg-blue-50 p-4 lg:p-6 rounded-xl text-center hover:bg-blue-100 transition-colors">
                <span className="block text-4xl font-bold text-blue-600 mb-2">ISO</span>
                <span className="text-gray-700 font-medium">9001 · 14001 · 45001</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Resource center teaser */}
      <section className="py-16 bg-[#0A1F30] text-white">
        <div className="container mx-auto px-4 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="text-3xl font-bold mt-0 mb-3">{c.resourcesHeading}</h2>
            <p className="text-lg text-gray-300 m-0">{c.resourcesBody}</p>
          </div>
          <div className="flex flex-wrap gap-3">
            {c.resourcesLinks.map(([to, label]) => (
              <Link key={to} to={lp(to)} className="px-6 py-3 rounded-lg border-2 border-white/80 text-white hover:bg-white hover:text-gray-900 font-semibold transition duration-300">
                {label}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
